document.addEventListener('DOMContentLoaded', function () {

  // Solo activar esta funcionalidad si existe la página de ventas mayoristas
  const paginaMayoristas = document.getElementById('ventas-mayoristas');
  if (!paginaMayoristas) return;

  // Crear popup
  const popup = document.createElement('div');

  popup.id = 'popup-mayoristas';

  popup.innerHTML = `
    <div class="mayorista-overlay"></div>

    <div class="mayorista-modal">

      <button type="button" class="mayorista-cerrar" aria-label="Cerrar">
        &times;
      </button>

      <h2>Ventas Mayoristas</h2>

      <p class="mayorista-subtitulo">
        Completa tus datos para contactarte con nuestro asesor.
      </p>

      <form id="form-mayoristas">

        <label for="mayorista-razon">
          Razón social o nombre comercial
        </label>

        <input
          type="text"
          id="mayorista-razon"
          required
          autocomplete="organization"
        >

        <label for="mayorista-nit">
          NIT o CI
        </label>

        <input
          type="text"
          id="mayorista-nit"
          required
        >

        <button type="submit" class="mayorista-whatsapp">
          Contactar por WhatsApp
        </button>

      </form>

    </div>
  `;

  document.body.appendChild(popup);

  // Estilos del popup
  const estilos = document.createElement('style');

  estilos.textContent = `
    #popup-mayoristas {
      display: none;
      position: fixed;
      inset: 0;
      z-index: 99999;
      align-items: center;
      justify-content: center;
    }

    #popup-mayoristas.activo {
      display: flex;
    }

    .mayorista-overlay {
      position: absolute;
      inset: 0;
      background: rgba(0,0,0,.55);
    }

    .mayorista-modal {
      position: relative;
      width: calc(100% - 40px);
      max-width: 460px;
      background: #fff;
      border-radius: 12px;
      padding: 35px;
      box-shadow: 0 15px 50px rgba(0,0,0,.25);
      z-index: 1;
    }

    .mayorista-modal h2 {
      margin: 0 0 8px;
      text-align: center;
      font-size: 26px;
    }

    .mayorista-subtitulo {
      text-align: center;
      margin: 0 0 25px;
      color: #666;
    }

    .mayorista-modal label {
      display: block;
      margin: 15px 0 6px;
      font-weight: 600;
    }

    .mayorista-modal input {
      width: 100%;
      box-sizing: border-box;
      padding: 12px;
      border: 1px solid #ccc;
      border-radius: 6px;
      font-size: 16px;
    }

    .mayorista-modal input:focus {
      outline: none;
      border-color: #a66fb5;
    }

    .mayorista-whatsapp {
      width: 100%;
      margin-top: 24px;
      padding: 13px 18px;
      background: #a66fb5;
      color: #fff;
      border: 0;
      border-radius: 6px;
      font-size: 16px;
      cursor: pointer;
    }

    .mayorista-whatsapp:hover {
      opacity: .9;
    }

    .mayorista-cerrar {
      position: absolute;
      right: 15px;
      top: 10px;
      border: 0;
      background: transparent;
      font-size: 30px;
      line-height: 1;
      cursor: pointer;
      color: #555;
    }

    @media (max-width: 500px) {
      .mayorista-modal {
        padding: 30px 22px;
      }
    }
  `;

  document.head.appendChild(estilos);

  let whatsappSeleccionado = '';

  // Abrir popup desde cualquiera de las tarjetas
  document.querySelectorAll('.mayorista-contacto').forEach(function (boton) {

    boton.addEventListener('click', function () {

      whatsappSeleccionado = boton.dataset.whatsapp;

      popup.classList.add('activo');

      setTimeout(function () {
        document.getElementById('mayorista-razon').focus();
      }, 100);

    });

  });

  // Cerrar popup
  function cerrarPopup() {
    popup.classList.remove('activo');
  }

  popup.querySelector('.mayorista-cerrar')
    .addEventListener('click', cerrarPopup);

  popup.querySelector('.mayorista-overlay')
    .addEventListener('click', cerrarPopup);

  // Enviar a WhatsApp
  document.getElementById('form-mayoristas')
    .addEventListener('submit', function (event) {

      event.preventDefault();

      const razon = document
        .getElementById('mayorista-razon')
        .value
        .trim();

      const nit = document
        .getElementById('mayorista-nit')
        .value
        .trim();

      if (!razon || !nit || !whatsappSeleccionado) return;

      const mensaje =
`Hola, quisiera comprar al por mayor
Razón social o nombre comercial: ${razon}
NIT o CI: ${nit}`;

      const enlace =
        'https://wa.me/' +
        whatsappSeleccionado +
        '?text=' +
        encodeURIComponent(mensaje);

      window.open(enlace, '_blank');

    });

});